module.exports = __webpack_public_path__ + "static/assets/13e0854d568d5bdf3b2fb4f5f06ffcdf.svg";